import { render, staticRenderFns } from "./BrandingRestoreControl.vue?vue&type=template&id=2c2db726&scoped=true&"
import script from "./BrandingRestoreControl.vue?vue&type=script&lang=js&"
export * from "./BrandingRestoreControl.vue?vue&type=script&lang=js&"
import style0 from "./BrandingRestoreControl.vue?vue&type=style&index=0&id=2c2db726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2db726",
  null
  
)

export default component.exports